import { render, staticRenderFns } from "./update-email.vue?vue&type=template&id=6e6a442a&scoped=true&lang=pug&"
import script from "./update-email.vue?vue&type=script&lang=js&"
export * from "./update-email.vue?vue&type=script&lang=js&"
import style0 from "./update-email.vue?vue&type=style&index=0&id=6e6a442a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6a442a",
  null
  
)

export default component.exports